module.exports = "/images/640a4e4691d85ec66f94981d7e725d6f.svg";